import { render, staticRenderFns } from "./myEvaluation.vue?vue&type=template&id=80988a14&scoped=true&"
import script from "./myEvaluation.vue?vue&type=script&lang=js&"
export * from "./myEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./myEvaluation.vue?vue&type=style&index=0&id=80988a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80988a14",
  null
  
)

export default component.exports